module.exports = __webpack_public_path__ + "static/media/cartoes_cabal.08e2fefc.svg";